import { IdentityProvider } from '@/client/accounts/types/account-user-management.type';
import { SimpleLockIcon } from '@/utils/helpers';
import { TFunction } from 'i18next';
import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled.i`
  margin-right: var(--xsmall-padding);
  position: relative;
  top: var(--xxxsmall-padding);
`;

export const getSyncedFieldTooltip = (
  tooltip: string | undefined,
  isSyncedField: boolean | undefined,
  isAdSyncedField: boolean | undefined,
  t: TFunction,
): string | undefined => {
  if (tooltip) {
    return tooltip;
  }

  if (!isSyncedField) {
    return undefined;
  }

  const identityProvider: IdentityProvider = isAdSyncedField
    ? IdentityProvider.MICROSOFT_ENTRA_ID
    : IdentityProvider.GOOGLE_WORKSPACE;

  return t('user.identityProvider.syncedField', { identityProvider });
};

export const SyncedFieldLockIcon: React.FC = () => (
  <StyledIcon>
    <SimpleLockIcon />
  </StyledIcon>
);
